import React, { useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { Menu } from 'primereact/menu';
import { MenuItem } from 'primereact/menuitem';
import { ChevronDown } from '../../icons/OurIcons';

type ReixMenuProps = {
  title: string;
  items: MenuItem[];
  onTriggerClick?: (event: React.MouseEvent<HTMLButtonElement>) => boolean | void;
};

export const ReixMenu = ({ title, items, onTriggerClick }: ReixMenuProps) => {
  const toast = useRef(null);
  const menu = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const chevronSyling = isMenuOpen ? 'rotate-180' : '';

  return (
    <>
      <Toast ref={toast} />
      <Menu
        model={items}
        popup
        ref={menu}
        id="popup_menu"
        onHide={() => setIsMenuOpen(false)}
        onShow={() => setIsMenuOpen(true)}
        className="border-none p-0 mt-2 w-fit"
        pt={{
          root: {
            style: { minWidth: '10rem' },
          },
          content: {
            className: 'bg-transparent',
          },
          action: {
            className: 'p-2',
          },
          label: {
            className: 'text-black',
          },
        }}
      />
      <button
        onClick={(event) => {
          if (onTriggerClick && onTriggerClick(event) === false) return;
          menu.current.toggle(event);
        }}
        className="w-full bg-reix-blue text-white p-2 h-full rounded-lg flex gap-2 items-center pr-8"
      >
        {title}
        <div className={`${chevronSyling} duration-300`}>
          <ChevronDown size={10} />
        </div>
      </button>
    </>
  );
};
